// RigSentinel Owner Dashboard V1 — thin fetch wrapper.
// Every call sends the session cookie; the backend independently verifies
// role === "owner" on every request. No client-side owner check here.
const API_BASE = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API_BASE}/api/admin/owner-dashboard`;

async function _handle(res) {
  if (res.status === 401) throw new Error("Sign in as the owner account to view this dashboard.");
  if (res.status === 403) throw new Error("This dashboard is only available to the owner account.");
  if (!res.ok) throw new Error("Could not load owner dashboard data.");
  return res.json();
}

function _qs(params) {
  const entries = Object.entries(params || {}).filter(
    ([, v]) => v !== undefined && v !== null && v !== ""
  );
  return new URLSearchParams(entries).toString();
}

export async function fetchOverview({ range = "30d", from, to } = {}) {
  const qs = _qs({ range, from, to });
  const res = await fetch(`${BASE}/overview?${qs}`, { credentials: "include" });
  return _handle(res);
}

export async function fetchUsers(params = {}) {
  const qs = _qs(params);
  const res = await fetch(`${BASE}/users?${qs}`, { credentials: "include" });
  return _handle(res);
}

export async function fetchUserDetail(userId) {
  const res = await fetch(`${BASE}/users/${encodeURIComponent(userId)}`, { credentials: "include" });
  return _handle(res);
}

export function exportCsvUrl(filters = {}) {
  return `${BASE}/export.csv?${_qs(filters)}`;
}
